import { Link } from "react-router-dom";
import { Calendar, MapPin, Star, Sparkles } from "lucide-react";
import Badges from "./Badges";

const categoryLabels = {
  marche: "Marché", foire: "Foire", salon: "Salon",
  festival: "Festival", exposition: "Exposition", autre: "Autre",
};

export default function EventCard({ event }) {
  const img = event.images?.[0] || "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800";
  const start = new Date(event.start_date).toLocaleDateString("fr-FR", { day: "numeric", month: "long" });
  return (
    <Link
      to={`/events/${event.id}`}
      data-testid={`event-card-${event.id}`}
      className={`group block bg-white border transition-all duration-300 ${
        event.is_boosted
          ? "border-accent/40"
          : "border-ink/10 hover:border-ink/30"
      }`}
    >
      <div className="aspect-[4/5] overflow-hidden bg-cream relative">
        <img
          src={img}
          alt={event.title}
          className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-[800ms] ease-out"
        />
        {event.is_boosted && (
          <div
            data-testid={`featured-badge-${event.id}`}
            className="absolute top-4 left-4 inline-flex items-center gap-1.5 bg-accent text-white text-[10px] font-bold uppercase tracking-[0.22em] px-3 py-1.5"
          >
            <Sparkles className="h-3 w-3" /> À la une
          </div>
        )}
      </div>
      <div className="p-6">
        <div className="flex items-center justify-between mb-3">
          <span className="text-label text-ink/40">
            {categoryLabels[event.category] || event.category}
          </span>
          {event.rating_avg > 0 && (
            <div className="flex items-center gap-1 text-xs">
              <Star className="h-3 w-3 fill-accent text-accent" />
              <span className="font-semibold text-ink">{event.rating_avg}</span>
            </div>
          )}
        </div>
        <h3 className="font-heading font-light text-2xl leading-tight tracking-editorial text-ink mb-3 line-clamp-2 group-hover:text-accent transition-colors">
          {event.title}
        </h3>
        {event.badges?.length > 0 && (
          <div className="mb-3">
            <Badges badges={event.badges} variant="card" max={3} />
          </div>
        )}
        <div className="flex items-center gap-4 text-[12px] text-ink/55 pt-4 border-t border-ink/10">
          <span className="flex items-center gap-1.5"><Calendar className="h-3 w-3" /> {start}</span>
          <span className="flex items-center gap-1.5"><MapPin className="h-3 w-3" /> {event.city}</span>
        </div>
      </div>
    </Link>
  );
}
